import { Toolbar, ToolbarProps, styled } from '@mui/material';
import React from 'react';

interface StyledToolbarProps extends Omit<ToolbarProps, 'px'> {
  px?: string;
}

const StyledToolbarBase = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== 'px',
})<StyledToolbarProps>(({ className, px }) => {
  return {
    height: '100%', // ✅ fills the full AppBar height
    minHeight: '80px',
    paddingTop: 0, // ✅ avoids vertical compression from padding
    paddingBottom: 0,
    paddingLeft: px || '1.25rem',
    paddingRight: px || '1.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    className: `react-StyledToolbar ${className || ''}`.trim(),
  };
});

export const StyledToolbar: React.FC<StyledToolbarProps> = ({ ...props }) => {
  return <StyledToolbarBase {...props} disableGutters />;
};
